import React from "react";
import "../../styles/hero.css";
import SmokeEffect from "components/smokeEffect/SmokeEffect";
const Hero = () => {
  return (
    <div className="hero-section">
      <SmokeEffect />
      <div className="hero-content">
        <h1>TRADEIQ</h1>
        {/* <input type="text" placeholder="What do you want to know?" /> */}
        <p>
          TRADEIQ is Africa’s intelligent B2B commerce ecosystem powering trade,
          distribution, retail intelligence, and financial inclusion across the
          continent.
        </p>
        {/* <button>Read Announcement</button> */}
      </div>
    </div>
  );
};

export default Hero;
